module.exports = __webpack_public_path__ + "img/dikidi.838c7c0f.png";